import React, { useRef, useState } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { PopupMenu, Button } from 'quantux-ui';
import { gray, blue } from '../../theme';

const FileCard = (props) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef();
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);

  const styles = StyleSheet.create({
    popupMenuContainer: {
      background: '#083050',
      width: '150px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    menuItem: {
      cursor: 'pointer',
      background: blue[900],
      color: gray[300],
      padding: '4px',
      lineHeight: '16px',
      borderBottom: `1px solid ${gray[600]}`,
      fontSize: '14px',
      // height: '40px',
      ':hover': {
        background: gray[500],
        color: 'white'
      }
    },
    menuItemIconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40px',
      width: '40px'
    },
    menuItemIcon: {
      fontSize: '20px'
    }
  });

  return (
    <div
      className={`fx fx__v-center p-2 ${props.className}`}
      style={{
        height: '40px',
        background: gray[500],
        borderRadius: '4px',
        position: 'relative'
      }}
      ref={menuRef}
    >
      {showDeleteWarning &&
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '100%'
          }}
        >
          <Button
            btnType='primary'
            className='mr-2'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '80px',
              minHeight: '32px',
              maxHeight: '32px',
              fontSize: '14px'
            }}
            isOutlineBtn
            onClick={() => setShowDeleteWarning(false)}
          >
            Cancel
          </Button>
          <Button
            btnType='warning'
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '80px',
              minHeight: '32px',
              maxHeight: '32px',
              fontSize: '14px'
            }}
            onClick={() => props.onDelete()}
          >
            Delete
          </Button>
        </div>
      }
      {props.fileKey.endsWith('pdf')
        ? <i style={{ fontSize: '20px' }} className={`fa fa-file-pdf-o ${showDeleteWarning ? 'd-none' : ''}`} />
        : <i style={{ fontSize: '20px' }} className={`fa fa-file-image-o ${showDeleteWarning ? 'd-none' : ''}`} />
      }
      {!showDeleteWarning &&
        <div
          className='fx fx__v-center ml-2'
          style={{ flexGrow: '1', color: 'white', justifyContent: 'space-between' }}
        >
          <div style={{ fontSize: '14px', lineHeight: '14px' }}>
            <div>{props.fileName}</div>
            {props.numberOfPages > 0 &&
              <div>{`${props.numberOfPages} page(s)`}</div>
            }
          </div>
          {props.isLoading
            ? <i className='fa fa-cog fa-spin fa-2x fa-fw' />
            : <i
                className='pr-2 fa fa-ellipsis-v'
                onClick={() => {
                  if (props.showMenu) {
                    setShowMenu(!showMenu);
                  }
                }}
              />
          }
          <PopupMenu
            top={40}
            right={1}
            visible={showMenu}
            parent={menuRef}
            position="absolute"
            onOutsideClick={() => { setShowMenu(false); }}
          >
            <div className={css(styles.popupMenuContainer)}>
              {/* View Form */}
              <div
                className={`m-item ${css(styles.menuItem)}`}
                onClick={() => {
                  setShowMenu(false);
                  props.onView();
                }}
              >
                <div className={css(styles.menuItemIconContainer)}>
                  <i className={`fa fa-eye ${css(styles.menuItemIcon)}`} />
                </div>
                <div>View Form</div>
              </div>
              {/* Edit Form */}
              <div
                className={`m-item ${css(styles.menuItem)}`}
                onClick={() => {
                  setShowMenu(false);
                  props.onEdit();
                }}
              >
                <div className={css(styles.menuItemIconContainer)}>
                  <i className={`fa fa-pencil ${css(styles.menuItemIcon)}`} />
                </div>
                <div>Edit Form</div>
              </div>
              {/* Edit Form */}
              <div
                className={`m-item ${css(styles.menuItem)}`}
                onClick={() => {
                  setShowMenu(false);
                  setShowDeleteWarning(true);
                }}
              >
                <div className={css(styles.menuItemIconContainer)}>
                  <i className={`fa fa-trash ${css(styles.menuItemIcon)}`} />
                </div>
                <div>Delete Form</div>
              </div>
            </div>
          </PopupMenu>
        </div>
      }
    </div>
  );
};

FileCard.defaultProps = {
  fileKey: 'jpg',
  className: '',
  numberOfPages: 0,
  showMenu: true
};

export default FileCard;
